import React from 'react';

import IMG_1 from '../../../Images/gallery/savile/img_1.png';
import IMG_2 from '../../../Images/gallery/savile/img_2.png';
import IMG_3 from '../../../Images/gallery/savile/img_3.png';
import IMG_4 from '../../../Images/gallery/savile/img_4.png';

export const Savile_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>SAVILÉ</span>,
  },
];

export const Title_1 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>SAVILÉ</span>,
  },
];

export const Title_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PHOTOGRAPHY</span>,
  },
];

export const Savile_Gallery = [
  { id: 1, src: IMG_1, colSpan: 4, rowSpan: 6 },
  { id: 2, src: IMG_2, colSpan: 4, rowSpan: 4 },
  { id: 3, src: IMG_3, colSpan: 2, rowSpan: 4 },
  { id: 4, src: IMG_4, colSpan: 2, rowSpan: 4 },
];
